export default function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


//////////////////
// WEBPACK FOOTER
// ../~/react-transition-group/~/@babel/runtime/helpers/esm/assertThisInitialized.js
// module id = 3103
// module chunks = 121